/**
 *  @class
 *  @function CollectionTabs
 */

// if (!customElements.get('collection-tabs')) {
//   class CollectionTabs extends HTMLElement {

//     constructor() {
//       super();
//     }
//     connectedCallback() {
//       setTimeout(() => {
//         this.target = this.dataset.target;
//         this.buttons = Array.from(this.querySelectorAll('button'));
//         this.buttons.forEach((button, i) => {
//           button.addEventListener('click', (event) => {
//             let handle = button.dataset.collection;
//             [].forEach.call(this.buttons, function(el) {
//               el.classList.remove('active');
//             });

//             button.classList.add('active');

//             if (handle) {
//               this.toggleCollection(handle);
//             }

//             event.preventDefault();
//           });
//         });
//       }, 20);
//       if (Shopify.designMode) {
//         this.addEventListener('shopify:block:select', (event) => {
//           let index = this.buttons.indexOf(event.target);

//           this.buttons[index].dispatchEvent(new Event('click'));
//         });
//       }
//     }
//     toggleCollection(handle) {
//       let slider = document.getElementById(this.target),
//         products = slider.querySelectorAll(`.columns:not([data-collection*="${handle}"])`),
//         active_products = slider.querySelectorAll(`[data-collection*="${handle}"]`),
//         flkty = Flickity.data(slider);
//       [].forEach.call(products, function(el) {
//         el.classList.remove('carousel__slide');
//         slider.append(el);
//       });
//       [].forEach.call(active_products, function(el) {
//         if (el.dataset.collection === handle) {
//           el.classList.add('carousel__slide');
//         } else {
//           el.classList.remove('carousel__slide');
//           slider.append(el);
//         }
//       });
//       flkty.insert(active_products);
//       flkty.reloadCells();
//       flkty.select(0, 0, 1);
//     }
//   }
//   customElements.define('collection-tabs', CollectionTabs);
// }




if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
      this.sliderBreakpoint = 1068; // threshold for mobile
    }

    connectedCallback() {
      this.target = this.dataset.target;
      this.slider = document.getElementById(this.target);

      setTimeout(() => {
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.buttons.forEach((button) => {
          button.addEventListener('click', (event) => {
            const handle = button.dataset.collection;

            this.buttons.forEach(el => el.classList.remove('active'));
            button.classList.add('active');

            if (handle) this.toggleCollection(handle);

            event.preventDefault();
          });
        });
      }, 20);

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.buttons.indexOf(event.target);
          this.buttons[index].dispatchEvent(new Event('click'));
        });
      }

      this.setupSlider();
      window.addEventListener('resize', this.setupSlider.bind(this));
    }

    setupSlider() {
      const isMobile = window.innerWidth < this.sliderBreakpoint;
      const flkty = Flickity.data(this.slider);

      if (isMobile && !flkty) {
        // Initialize slider on mobile
        new Flickity(this.slider, {
          cellAlign: 'left',
          contain: true,
          wrapAround: false,
          pageDots: true
        });
      } else if (!isMobile && flkty) {
        // Destroy slider on desktop
        flkty.destroy();
      }
    }

    toggleCollection(handle) {
      const slider = this.slider;
      const flkty = Flickity.data(slider);

      const products = slider.querySelectorAll(`.columns:not([data-collection*="${handle}"])`);
      const active_products = slider.querySelectorAll(`[data-collection*="${handle}"]`);

      products.forEach(el => {
        el.classList.remove('carousel__slide');
        slider.append(el);
      });

      active_products.forEach(el => {
        if (el.dataset.collection === handle) {
          el.classList.add('carousel__slide');
        } else {
          el.classList.remove('carousel__slide');
          slider.append(el);
        }
      });

      if (flkty) {
        flkty.insert(active_products);
        flkty.reloadCells();
        flkty.select(0, false, true);
      }
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
